import { Injectable } from '@angular/core';
import { filter } from 'rxjs';
import { FlagConfigState, WebAngularSharedDataAccessFeatureFlagApisService } from '../services/feature-flags.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/feature-flags.service";
/**
 * A Guard that actives a route based on if a feature flag value is true
 * Use the data property of the route to define the required feature
 * https://stackoverflow.com/a/42721468
 *
 * @example
 *  const routes: Routes = [{
      path: '',
      component: SomeComponent,
      data: {
        featureFlagGuard: {flagname: 'some_flagname'}
      },
      canActivate: [WebAngularSharedDataAccessFeatureFlagApiGuard]
 *  }];
 * @export
 * @class WebAngularSharedDataAccessFeatureFlagApiGuard
 * @implements {CanActivate}
 */
export class WebAngularSharedDataAccessFeatureFlagReadinessApiGuard {
    constructor(featureFlagsService) {
        this.featureFlagsService = featureFlagsService;
    }
    canActivate() {
        return this.featureFlagsService.flagConfigReady$.pipe(filter((val) => val === FlagConfigState.ready));
    }
    static { this.ɵfac = function WebAngularSharedDataAccessFeatureFlagReadinessApiGuard_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WebAngularSharedDataAccessFeatureFlagReadinessApiGuard)(i0.ɵɵinject(i1.WebAngularSharedDataAccessFeatureFlagApisService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WebAngularSharedDataAccessFeatureFlagReadinessApiGuard, factory: WebAngularSharedDataAccessFeatureFlagReadinessApiGuard.ɵfac }); }
}
//# sourceMappingURL=feature-flag-readiness.guard.js.map